"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidNamePageValidationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_html_parser_1 = require("react-html-parser");
var journey_services_1 = require("@athena-portal/journey-services");
var PageValidationMessage_1 = require("../helpers/PageValidationMessage");
var InvalidNamePageValidationWidget = /** @class */ (function (_super) {
    __extends(InvalidNamePageValidationWidget, _super);
    function InvalidNamePageValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
        };
        _this.state = {
            hasInvalidNameForDriver: false
        };
        return _this;
    }
    InvalidNamePageValidationWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationMessage = journeyState["hidePageValidationErrorMessage"] || false;
        var bottomText = this.renderHtml(this.getSetting("bottomText")) || "Please try again.";
        var topText = this.getSetting("topText");
        if (bottomText && !hidePageValidationMessage && this.hasInvalidDriverName()) {
            return ((0, jsx_runtime_1.jsx)(PageValidationMessage_1.PageValidationMessage, { topText: topText, bottomText: bottomText, handleCloseFunction: this.handleClose }));
        }
        else {
            return null;
        }
    };
    InvalidNamePageValidationWidget.prototype.componentDidMount = function () {
        var interaction = this.props.engine.getInteraction();
        if (interaction.uistate.allDriverNamesValid == null && !this.hasInvalidDriverName()) {
            this.props.onStateChange("uistate.allDriverNamesValid", true);
            this.executeEvent("change");
        }
    };
    InvalidNamePageValidationWidget.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            }
        });
    };
    InvalidNamePageValidationWidget.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    InvalidNamePageValidationWidget.prototype.hasInvalidDriverName = function () {
        var interaction = this.props.engine.getInteraction();
        var hasInvalidNameForDriver = this.isInvalidPolicyHolderName(interaction) || this.hasInvalidAdditionalDriverName(interaction);
        if (this.state.hasInvalidNameForDriver !== hasInvalidNameForDriver) {
            this.setState({ hasInvalidNameForDriver: hasInvalidNameForDriver });
        }
        this.setPageValidationMessage(hasInvalidNameForDriver);
        return hasInvalidNameForDriver;
    };
    InvalidNamePageValidationWidget.prototype.isInvalidPolicyHolderName = function (interaction) {
        var expression = /^[a-z ,.'-]+$/i;
        var policyHolder = interaction.policyHolder;
        return !(expression.test(policyHolder.firstName) && expression.test(policyHolder.lastName));
    };
    InvalidNamePageValidationWidget.prototype.hasInvalidAdditionalDriverName = function (interaction) {
        var additionalDrivers = interaction.additionalDrivers;
        var expression = /^[a-z ,.'-]+$/i;
        return additionalDrivers === undefined || additionalDrivers === null || additionalDrivers.length === 0 ?
            false : !additionalDrivers.every(function (element) {
            return expression.test(element.firstName) && expression.test(element.lastName);
        });
    };
    InvalidNamePageValidationWidget.prototype.setPageValidationMessage = function (hasInvalidDriverName) {
        var _a;
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationMessage = journeyState["hidePageValidationErrorMessage"] === true || false;
        if (hidePageValidationMessage === true && hasInvalidDriverName) {
            this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = false, _a));
        }
    };
    return InvalidNamePageValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.InvalidNamePageValidationWidget = InvalidNamePageValidationWidget;
//# sourceMappingURL=InvalidNamePageValidatonWidget.js.map